import Default from './default';
import Primary from './primary';
import Secondary from './secondary';

const Video = {
  Default,
  Primary,
  Secondary,
};

export default Video;
